jQuery(function () {
    var selectPlant = $('.plant-edit__select-plant');
    var newPlant = $('.plant-edit__new-plant');
    var tabs = $('.js-add-new-plant-btn, .js-select-plant-btn');
    if (selectPlant.length < 1) {
        return;
    }
    $('.js-add-new-plant-btn').on('click', function () {
        tabs.removeClass('tab--selected');
        $(this).addClass('tab--selected');
        selectPlant.hide();
        newPlant.show();
    });
    $('.js-select-plant-btn').on('click', function () {
        tabs.removeClass('tab--selected');
        $(this).addClass('tab--selected');
        newPlant.hide();
        selectPlant.show();
    });
});
